import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import useNavItems, { isGroupItem } from "lib/hooks/useNavItems";

import IconSvg from "ui/shared/IconSvg";
import NavLink from "../vertical/NavLink";
import NavLinkGroup from "./NavLinkGroup";
import NavLinkRewards from "../vertical/NavLinkRewards";
import NavigationPromoBanner from "../promoBanner/NavigationPromoBanner";
import React from "react";
import StakingLink from "../StakingLink";
import styles from "./navigate.module.css";
import { useColorModeValue } from "toolkit/chakra/color-mode";
import useIsAuth from "ui/snippets/auth/useIsAuth";

interface Props {
  onNavLinkClick?: () => void;
  isMarketplaceAppPage?: boolean;
}

const NavigationMobile = ({ onNavLinkClick, isMarketplaceAppPage }: Props) => {
  const { mainNavItems, accountNavItems } = useNavItems();
  const [openedGroupIndex, setOpenedGroupIndex] = React.useState<number>(-1);
  const isOpen = openedGroupIndex !== -1;

  const isAuth = useIsAuth();
  const iconColor = useColorModeValue("blue.600", "blue.300");
  const isCollapsed = isMarketplaceAppPage ? false : undefined;

  return (
    <Flex
      flexDirection="column"
      h="100%"
      overflow="hidden"
      className={styles.hiddenRoot}
    >
      <Box flex="1" overflow="hidden" position="relative">
        <Box
          className={`${styles.navWrapper} ${
            !isOpen ? styles.isVisible : styles.isHidden
          }`}
        >
          <Box as="nav" mt={6}>
            <VStack w="100%" as="ul" gap="1" alignItems="flex-start">
              {mainNavItems.map((item, index) =>
                isGroupItem(item) ? (
                  <NavLinkGroup
                    key={item.text}
                    item={item}
                    onClick={() => setOpenedGroupIndex(index)}
                    isExpanded={isMarketplaceAppPage}
                  />
                ) : (
                  <NavLink
                    key={item.text}
                    item={item}
                    onClick={onNavLinkClick}
                    isCollapsed={isCollapsed}
                  />
                ),
              )}
            </VStack>
          </Box>
          {isAuth && (
            <Box
              as="nav"
              mt={3}
              pt={3}
              borderTopWidth="1px"
              borderColor="border.divider"
            >
              <VStack as="ul" gap="1" alignItems="flex-start">
                <NavLinkRewards
                  onClick={onNavLinkClick}
                  isCollapsed={isCollapsed}
                />
                {accountNavItems.map((item) => (
                  <NavLink
                    key={item.text}
                    item={item}
                    onClick={onNavLinkClick}
                    isCollapsed={isCollapsed}
                  />
                ))}
              </VStack>
            </Box>
          )}
          <NavigationPromoBanner isCollapsed={isCollapsed} />
        </Box>

        <Box
          className={`${styles.navWrapper} ${
            isOpen ? styles.isVisible : styles.isHidden
          }`}
        >
          <Flex
            alignItems="center"
            px={2}
            py={2.5}
            w="100%"
            h="50px"
            onClick={() => setOpenedGroupIndex(-1)}
            mb={1}
            cursor="pointer"
          >
            <IconSvg
              name="arrows/east-mini"
              boxSize={6}
              mr={2}
              color={iconColor}
            />
            <Text color="text.secondary" fontSize="sm">
              {mainNavItems[openedGroupIndex]?.text || ""}
            </Text>
          </Flex>
          <Box w="100%" as="ul">
            {openedGroupIndex !== -1 &&
              isGroupItem(mainNavItems[openedGroupIndex]) &&
              (mainNavItems[openedGroupIndex] as any).subItems?.map(
                (item: any, index: number) =>
                  Array.isArray(item) ? (
                    <Box
                      key={index}
                      w="100%"
                      as="ul"
                      _notLast={{
                        mb: 2,
                        pb: 2,
                        borderBottomWidth: "1px",
                        borderColor: "border.divider",
                      }}
                    >
                      {item.map((subItem: any) => (
                        <NavLink
                          key={subItem.text}
                          item={subItem}
                          onClick={onNavLinkClick}
                          isCollapsed={isCollapsed}
                        />
                      ))}
                    </Box>
                  ) : (
                    <Box key={item.text} mb={1}>
                      <NavLink
                        item={item}
                        onClick={onNavLinkClick}
                        isCollapsed={isCollapsed}
                      />
                    </Box>
                  ),
              )}
          </Box>
        </Box>
      </Box>

      <Box
        p={4}
        borderTopWidth="1px"
        borderColor="border.divider"
        flexShrink={0}
      >
        <StakingLink className="custom" />
      </Box>
    </Flex>
  );
};

export default NavigationMobile;
